import JustValidate from "just-validate";
import { Utils } from "../../assets/js/helpers/utils";
import { Ajax } from "../../assets/js/helpers/ajax";
import { Translation } from "../../assets/js/helpers/translation";
import { ToastHelper } from "../../assets/js/helpers/toast";

export class Form {

    cssClass = "c-form";
    cssFormFieldClass = `${this.cssClass}__field`;
    validationPotClass = `${this.cssClass}__validation-pot`;
    fieldWrapperSelectorName = "data-field-wrapper";
    fieldWrapperSelector = `[${this.fieldWrapperSelectorName}]`;
    validationMode = "just-validate";
    locked = false;
    coolDown = 10000;
    validator = null;
    validatorConfig = {};
    config = {
        "sendMode" : "sync",
        "messages" : {
            "sendSuccess" : Translation.translate("zaux_form_send_success"),
            "errorNotSent" : Translation.translate("zaux_form_send_error"),
            "tryLater" : Translation.translate("zaux_form_try_later")
        }
    };
    toast = null;
    loaderSelector = "[data-loader]";
    loader = null;
    loaderActiveClass = "--active";

    constructor(el = null) {
        this.el = el;

        if( this.el.hasAttribute("data-validation-mode") ){
            this.validationMode = this.el.getAttribute("data-validation-mode");
        }

        if( this.el.hasAttribute("data-config") ){
            var customConfig = JSON.parse(this.el.getAttribute("data-config"));
            this.config = Utils.arrayReplaceRecursive(this.config, customConfig);
        }

        switch( this.validationMode ){
            case "just-validate":
                //@see https://just-validate.dev/docs/instance for all available options
                if( this.el.hasAttribute("data-just-validate-config") ){
                    this.validatorConfig = JSON.parse(this.el.getAttribute('data-validation-config') );
                }else{
                    this.validatorConfig = {
                        errorFieldCssClass : [this.cssFormFieldClass + "--error"],
                        successFieldCssClass : [this.cssFormFieldClass + "--success"],
                        errorLabelCssClass : [this.cssClass + "__validation-label--error"],
                        successLabelCssClass : [this.cssClass + "__validation-label--success"],
                        focusInvalidField : true,
                        lockForm : true,
                        validateBeforeSubmitting : true
                    };
                }
                this.validatorConfig.colorWrong = null;
            break;
        }

        this.loader = this.el.querySelector(this.loaderSelector) || null;

        if( ToastHelper.getInstance() !== null){
            this.toast = ToastHelper.getInstance();
        }

        this.init();
    }

    showLoader(){
        if( this.loader !== null){
            this.loader.classList.add(this.loaderActiveClass);
        }
    }

    hideLoader(){
        if( this.loader !== null ){
            this.loader.classList.remove(this.loaderActiveClass);
        }
    }

    lockSend(){
        if( this.locked == false ){
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, this.coolDown);
        }
    }

    handleFormValidation(outCome){
        if( this.locked == true ){ 
            this.toast.show(this.config.messages.tryLater, "error");
            return; 
        }
        this.lockSend();
        switch( outCome ){
            case "success":
                if( this.config.sendMode == "async" ){
                    this.showLoader();
                    try{
                        Ajax.post(
                            this.el.action,
                            new FormData(this.el)
                        ).then( response => {
                            this.hideLoader();
                            if( response !== undefined ){
                                if( response.message !== undefined ){
                                    ToastHelper.show(response.message.text, response.message.type);
                                    if( response.message.type == "success"){
                                        this.cleanFields();
                                    }
                                }else{
                                    ToastHelper.show(this.config.messages.sendSuccess, "success");
                                    this.cleanFields();
                                }
                            }else{
                                ToastHelper.show(this.config.messages.errorNotSent, "error");
                            }
                        });
                    }catch(e){
                        this.hideLoader();
                        this.toast.show(this.config.messages.errorNotSent, "error");
                        console.log(e);
                    }
                }else{
                    this.el.submit();
                }
            break;  
        }
    }

    cleanFields(){
        this.el.querySelectorAll("[class*=__field]").forEach( element => {
            element.value = "";
        });
    }

    init(){
        //Supports multiple validation modes if implemented. By Default just-validate is active
        switch( this.validationMode ) {
            case "just-validate":
                this.el.setAttribute("novalidate","novalidate");
                this.validator = new JustValidate(this.el, this.validatorConfig);
                
                //Validator setup
                this.el.querySelectorAll("[class*=__field], input:not([type=submit], textarea)").forEach( element => {

                    var rules = [];
                    var needsValidation = false;
                    var inputType = "";
                    var ruleObj = {};
                    var extraOpts = {};

                    //Check if it's required
                    if( element.hasAttribute("required") ){
                        ruleObj.rule = "required";
                        ruleObj.errorMessage = Translation.translate("zaux_field_required");
                        if( element.hasAttribute("data-required-msg") ){
                            ruleObj.errorMessage = element.getAttribute("data-required-msg");
                        }
                        rules.push(ruleObj);
                        needsValidation = true;
                    }

                    if( element.getAttribute("type") ){
                        inputType = element.getAttribute("type");
                        switch( inputType ){
                            case "email":
                                ruleObj = {};
                                ruleObj.rule = "email";
                                ruleObj.errorMessage = Translation.translate("zaux_email_format_invalid");
                                if( element.hasAttribute("data-format-msg") ){
                                    ruleObj.errorMessage = element.getAttribute("data-format-msg");
                                }
                                rules.push(ruleObj);
                                needsValidation = true;
                            break;
                            case "file":
                                ruleObj = {};

                                if( element.hasAttribute("required") ){
                                    //Checks if at least one file was selected
                                    ruleObj.rule = "minFilesCount";
                                    ruleObj.value = 1;
                                    ruleObj.errorMessage = Translation.translate("zaux_file_not_present");
                                    if( element.hasAttribute("data-required-msg") ){
                                        ruleObj.errorMessage = element.getAttribute("data-required-msg");
                                    }
                                    rules.push(ruleObj);
                                }

                                //If set on input, applies field specific rules about the file
                                //@see https://just-validate.dev/examples#files-validation
                                if( element.hasAttribute("data-file-rules") && JSON.parse(element.hasAttribute("data-file-rules")) ){
                                    ruleObj = {};
                                    ruleObj.rule = "files";
                                    ruleObj.value = JSON.parse(element.getAttribute("data-file-rules"));
                                    ruleObj.errorMessage = Translation.translate("zaux_file_format_invalid");
                                    if( element.hasAttribute("data-format-msg") ){
                                        ruleObj.errorMessage = element.getAttribute("data-format-msg");
                                    }
                                    rules.push(ruleObj);
                                }

                                needsValidation = true;
                            break;
                        }
                    }

                    //If validation is needed for the field we add the previously determined rules
                    if( needsValidation ){
                        //Change validation message location if a validation "pot" is present
                        if( element.closest(`.${this.cssFormFieldClass}-wrap, ${this.fieldWrapperSelector}`) ){
                            var wrapper = element.closest(`.${this.cssFormFieldClass}-wrap`);
                            if( wrapper.querySelector(`.${this.validationPotClass}`) ){
                                extraOpts.errorsContainer = wrapper.querySelector(`.${this.validationPotClass}`);
                            }
                        }
                        if( rules.length > 0 ){
                            this.validator.addField(element, rules, extraOpts);
                        }
                    }

                });
                
                this.validator.onSuccess(() => { this.handleFormValidation("success") });
                //this.validator.onFail(() => { this.handleFormValidation("failure") });
                
            break;
        }

    }

}       